import { generateSignedUrl } from '../store/modules/lives-socket';

export function getLiveDocumentsHeaders(contentType = null) {
  const headers = {
    Authorization: window.ApiToken ? window.ApiToken : `Bearer ${process.env.API_TOKEN}`
  };

  if (contentType) {
    headers['Content-Type'] = contentType;
  }

  return { headers };
}

export async function getSignedLiveDocumentsUrl(path) {
  const base = `${window.process.env.API_HOST_LIVE}${path}`;
  const normalized = base.startsWith('http') ? base : `https:${base}`;
  return generateSignedUrl(new URL(normalized));
}

export function normalizeLiveDocumentsResponse(payload) {
  const candidates = [
    payload && payload.data,
    payload && payload.data && payload.data.data,
    payload && payload.data && payload.data.documents,
    payload && payload.data && payload.data.files,
    payload && payload.data && payload.data.items,
    payload && payload.data && payload.data.data && payload.data.data.documents,
    payload && payload.data && payload.data.data && payload.data.data.files,
    payload && payload.data && payload.data.data && payload.data.data.items,
  ];

  const matchedCandidate = candidates.find(candidate => Array.isArray(candidate));
  if (matchedCandidate) {
    return matchedCandidate;
  }

  const singleDocument =
    (payload && payload.data && payload.data.document) ||
    (payload && payload.data && payload.data.file) ||
    (payload && payload.data && payload.data.id ? payload.data : null);

  return singleDocument ? [singleDocument] : [];
}

export function getLiveDocumentId(item) {
  return item && (item.id || item.documentId || item.fileId || item.key);
}

export function getLiveDocumentName(item) {
  return (
    (item &&
      (item.file_name ||
        item.fileName ||
        item.originalName ||
        item.documentName ||
        item.title)) ||
    'Document'
  );
}

export function getLiveDocumentUrl(item) {
  return (
    (item &&
      (item.url ||
        item.fileUrl ||
        item.documentUrl ||
        item.downloadUrl ||
        item.path)) ||
    ''
  );
}

export function isLiveDocumentPublic(item) {
  return !!(item && (item.public || item.isPublic));
}



// WEBPACK FOOTER //
// ./src/helpers/live-documents.js